module.exports = "/images/b282a0c38175de4275bb8100723b720c.png";